export class UploadFileBean {
  fileBase64: string | ArrayBuffer | null;
  fileName: string;
  fileType: string;
  referenceKey: string;

  constructor() {
    this.fileBase64 = "";
    this.fileName = "";
    this.fileType = "";
    this.referenceKey = "";
  }
}
